import { useState } from "react";
import { TextField } from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";
import { Button, useNotify, useRecordContext, useRefresh } from "react-admin";
import { dormitoryRequests } from "api/dormitoryApi";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";

const RefundDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");

  const amountValue = Number(amount);
  const amountTouched = amount !== "";
  const amountHasSupportedPrecision = /^\d+(\.\d{1,2})?$/.test(amount);
  const amountInvalid =
    amountTouched &&
    (!Number.isFinite(amountValue) || !amountHasSupportedPrecision || amountValue <= 0 || amountValue > record?.amount);
  const trimmedNote = note.trim();
  const noteInvalid = trimmedNote.length > 500;
  const confirmEnabled = amountTouched && !amountInvalid && !noteInvalid;

  const handleConfirm = async () => {
    if (!confirmEnabled) {
      return false;
    }

    try {
      await dataProvider.customRequest(
        dormitoryRequests.refundAccommodationPayment(record.accommodationId, record.id),
        { amount: amountValue, note: trimmedNote || null },
        "PUT",
      );
      notify("Връщането е отбелязано", { type: "success" });
      refresh();
    } catch (error) {
      if (error?.errorCode === "EC_TooLong_Argument_Note") {
        notify("Бележката трябва да е до 500 символа.", { type: "error" });
        return false;
      }

      throw error;
    }
  };

  return (
    <ConfirmModal
      onConfirm={handleConfirm}
      titleContent="Отбелязване на връщане"
      confirmEnabled={confirmEnabled}
      resetProps={() => {
        setAmount("");
        setNote("");
      }}
      triggerButton={
        <Button
          startIcon={<UndoIcon />}
          label="Отбележи връщане"
        />
      }
    >
      <TextField
        type="number"
        label="Сума"
        value={amount}
        onChange={e => setAmount(e.target.value)}
        inputProps={{ min: 0, max: record?.amount, step: "0.01" }}
        error={amountInvalid}
        helperText={amountInvalid ? `Въведете сума над 0 и до ${record?.amount}` : " "}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Бележка"
        value={note}
        onChange={e => setNote(e.target.value)}
        error={noteInvalid}
        helperText={noteInvalid ? "Бележката трябва да е до 500 символа." : `${trimmedNote.length}/500`}
        multiline
        rows={3}
        fullWidth
      />
    </ConfirmModal>
  );
};

export default RefundDialog;
